import useAssets from '../../../../../common/useAssets';
const cdn = useAssets(false);

let arrayList = []
for (let i = 1; i < 14; i++) {
    arrayList.push(cdn(`images/coBranding/${i}.png`))
}

export const logoList = arrayList
export const bgImg = cdn('images/coBranding/bg.png')